import { render, staticRenderFns } from "./EndMsgDialog.vue?vue&type=template&id=6e7c8591&scoped=true&"
import script from "./EndMsgDialog.vue?vue&type=script&lang=js&"
export * from "./EndMsgDialog.vue?vue&type=script&lang=js&"
import style0 from "./EndMsgDialog.vue?vue&type=style&index=0&id=6e7c8591&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7c8591",
  null
  
)

export default component.exports